import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Activity, Plus, X, Clock } from "lucide-react";
import { apiUrl } from "../../constants";
import axios from "axios";
import { toast } from "react-toastify";

const TokenInc = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [allToken, setAllToken] = useState([]);
  const [actionLoading, setActionLoading] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, activity: null });

  // Generate time slots from 11 AM to 10 PM with 40-minute intervals
  const generateTimeSlots = () => {
    const slots = [];
    let currentTime = new Date();
    currentTime.setHours(11, 0, 0, 0); // Start at 11 AM
    const endTime = new Date();
    endTime.setHours(22, 0, 0, 0); // End at 10 PM

    while (currentTime < endTime) {
      const startTime = new Date(currentTime);
      currentTime.setMinutes(currentTime.getMinutes() + 40);
      const endTimeSlot = new Date(currentTime);

      slots.push({
        start: startTime.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        end: endTimeSlot.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        startDate: startTime,
        endDate: endTimeSlot,
      });
    }

    return slots;
  };

  const getCurrentAndUpcomingSlots = () => {
    const slots = generateTimeSlots();
    const now = new Date();
    let currentSlot = null;
    let upcomingSlots = [];

    for (let i = 0; i < slots.length; i++) {
      const slot = slots[i];
      const slotStart = new Date();
      slotStart.setHours(
        slot.startDate.getHours(),
        slot.startDate.getMinutes(),
        0,
        0
      );
      const slotEnd = new Date();
      slotEnd.setHours(slot.endDate.getHours(), slot.endDate.getMinutes(), 0, 0);

      if (now >= slotStart && now < slotEnd) {
        currentSlot = { ...slot, index: i + 1 };
        // Get next 2 upcoming slots
        upcomingSlots = slots.slice(i + 1, i + 3).map((s, idx) => ({
          ...s,
          index: i + idx + 2,
        }));
        break;
      } else if (now < slotStart && !currentSlot) {
        // If no current slot, get upcoming slots
        upcomingSlots = slots.slice(i, i + 2).map((s, idx) => ({
          ...s,
          index: i + idx + 1,
        }));
        break;
      }
    }

    return { currentSlot, upcomingSlots };
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchActivities();
      getAllToken();
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isModalOpen]);

  const getAllToken = async () => {
    try {
      const tokendata = await axios.get(`${apiUrl}/activitytoken/`);
      setAllToken(tokendata.data.data);
    } catch (error) {
      console.error("Error fetching tokens:", error);
    }
  };

  const fetchActivities = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${apiUrl}/activity/activityfetch`);
      const data = response.data;
      setActivities(data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch activities");
      setLoading(false);
      console.error("Error fetching activities:", err);
    }
  };

  // function to get token data for a specific activity
  const getTokenData = (activityId) => {
    return (
      allToken.find((token) => token.activityId === activityId) || {
        count: 0,
        overAllCount: 0,
      }
    );
  };

  const handleActivityAction = async (activityId, activityName) => {
    // Open confirmation dialog instead of immediate action
    setConfirmDialog({ 
      isOpen: true, 
      activity: { id: activityId, name: activityName } 
    });
  };

  const handleConfirmIncrement = async () => {
    const { id: activityId, name: activityName } = confirmDialog.activity;
    setActionLoading(activityId);
    setConfirmDialog({ isOpen: false, activity: null });

    if (activityName.toLowerCase() === "trampoline") {
     
      const res=axios.post(`${apiUrl}/chances/bulk`,{
        activityId:activityId,
      })
      // console.log(res,"bulk")
      toast.success(`Trampoline slot assigned`);
      setActionLoading(null);
      return;
    }

    try {
      const res = await axios.post(`${apiUrl}/activitytoken/increment`, {
        activityId: activityId,
      });
      // console.log(res, "tokendata");
      toast.success(`Token added for ${activityName}!`);

      // Refresh token data to show updated counts
      await getAllToken();

      setTimeout(() => {
        closeModal();
      }, 1000);
    } catch (err) {
      console.error("Error triggering activity action:", err);
      toast.error(`Error adding token for ${activityName}`);
    } finally {
      setActionLoading(null);
    }
  };

  const handleCancelIncrement = () => {
    setConfirmDialog({ isOpen: false, activity: null });
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const containerStyle = {
    position: "fixed",
    bottom: "30px",
    right: "30px",
    display: isVisible ? "flex" : "none",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1000,
    gap: "16px",
  };

  const getIconStyle = (isHovered) => ({
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    transform: isHovered ? "scale(1.15) translateY(-4px)" : "scale(1)",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    boxShadow: isHovered
      ? "0 20px 40px rgba(102, 126, 234, 0.4), 0 8px 16px rgba(102, 126, 234, 0.3)"
      : "0 8px 25px rgba(102, 126, 234, 0.25), 0 4px 10px rgba(102, 126, 234, 0.15)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    position: "relative",
    overflow: "hidden",
  });

  const iconInnerStyle = {
    color: "white",
    width: "28px",
    height: "28px",
    transition: "all 0.3s ease",
    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
    zIndex: 2,
    position: "relative",
  };

  const glowStyle = (isHovered) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isHovered ? "120%" : "0%",
    height: isHovered ? "120%" : "0%",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)",
    transition: "all 0.6s ease",
    opacity: isHovered ? 1 : 0,
    pointerEvents: "none",
  });

  const pulseRingStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    border: "2px solid #667eea",
    opacity: 0,
    animation: "pulse 2s infinite ease-out",
  };

  const ModalContent = () => (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 9999 }}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={closeModal}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
            <Activity className="w-5 h-5 text-blue-600" />
            Activities & Tokens
          </h2>
          <button
            onClick={closeModal}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-500 mb-4">{error}</p>
              <button
                onClick={fetchActivities}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Retry
              </button>
            </div>
          ) : (
            <div className="space-y-3">
              {activities.map((activity) => {
                const tokenData = getTokenData(activity._id);
                const isProcessing = actionLoading === activity._id;
                const isTrampoline = activity.name.toLowerCase() === "trampoline";

                return (
                  <div
                    key={activity._id}
                    className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
                  >
                    <div className="flex-1">
                      <h3 className="font-medium text-gray-800 mb-1">
                        {activity.name}
                      </h3>
                      
                      {isTrampoline ? (
                        // Time slots for Trampoline
                        <div className="space-y-2 mt-2">
                          {(() => {
                            const { currentSlot, upcomingSlots } = getCurrentAndUpcomingSlots();
                            return (
                              <>
                                {currentSlot && (
                                  <div className="flex items-center gap-2 text-sm">
                                    <div className="flex items-center gap-1 text-green-600">
                                      <Clock className="w-3 h-3" />
                                      <span className="font-semibold">Ongoing:</span>
                                    </div>
                                    <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-md text-xs font-medium">
                                      {currentSlot.start} - {currentSlot.end}
                                    </span>
                                  </div>
                                )}
                                
                                {upcomingSlots.length > 0 && (
                                  <div className="text-sm">
                                    <div className="flex items-center gap-1 text-blue-600 mb-1">
                                      <Clock className="w-3 h-3" />
                                      <span className="font-semibold">Upcoming:</span>
                                    </div>
                                    <div className="flex flex-wrap gap-1">
                                      {upcomingSlots.map((slot, idx) => (
                                        <span
                                          key={idx}
                                          className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded-md text-xs"
                                        >
                                          {slot.start} - {slot.end}
                                        </span>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                
                                {!currentSlot && upcomingSlots.length === 0 && (
                                  <div className="text-sm text-gray-500">
                                    No active or upcoming slots
                                  </div>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      ) : (
                        // Regular token display for other activities
                        <div className="flex gap-4 text-sm text-gray-600">
                          <span className="flex items-center gap-1">
                            <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                            Ongoing Token:{" "}
                            <span className="font-semibold text-green-600">
                              {tokenData.count}
                            </span>
                          </span>
                          <span className="flex items-center gap-1">
                            <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                            Allocated Token:{" "}
                            <span className="font-semibold text-blue-600">
                              {tokenData.overAllCount}
                            </span>
                          </span>
                        </div>
                      )}
                    </div>

                    <button
                      onClick={() =>
                        handleActivityAction(activity._id, activity.name)
                      }
                      disabled={isProcessing}
                      className={`ml-3 p-2 text-white rounded-full transition-all duration-200 group ${
                        isProcessing
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-blue-600 hover:bg-blue-700 hover:scale-105"
                      }`}
                      title={`Add token for ${activity.name}`}
                    >
                      {isProcessing ? (
                        <div className="w-4 h-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                      ) : (
                        <Plus className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      )}
                    </button>
                  </div>
                );
              })}

              {activities.length === 0 && !loading && (
                <div className="text-center py-8 text-gray-500">
                  No activities found
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const ConfirmDialog = () => (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 10000 }}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm"
        onClick={handleCancelIncrement}
      />

      {/* Dialog */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 p-6 transform transition-all">
        <div className="text-center">
          {/* Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-4">
            <Activity className="h-8 w-8 text-blue-600" />
          </div>

          {/* Title */}
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Confirm Increment
          </h3>

          {/* Message */}
          <p className="text-gray-600 mb-6">
            Are you sure you want to increment the token for{" "}
            <span className="font-semibold text-gray-900">
              {confirmDialog.activity?.name}
            </span>
            ?
          </p>

          {/* Buttons */}
          <div className="flex gap-3">
            <button
              onClick={handleCancelIncrement}
              className="flex-1 px-4 py-2.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirmIncrement}
              className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium shadow-lg shadow-blue-200"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.7;
          }
          100% {
            transform: translate(-50%, -50%) scale(1.4);
            opacity: 0;
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        .float-animation {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>

      <div style={containerStyle} className="float-animation">
        <div
          style={getIconStyle(hoveredIcon === "activity")}
          onMouseEnter={() => setHoveredIcon("activity")}
          onMouseLeave={() => setHoveredIcon(null)}
          onClick={openModal}
        >
          <div style={glowStyle(hoveredIcon === "activity")} />
          <div style={pulseRingStyle} />
          <Activity style={iconInnerStyle} />

          {/*notification badge */}
          <span
            style={{
              position: "absolute",
              top: "-2px",
              right: "-2px",
              backgroundColor: "#ef4444",
              color: "white",
              fontSize: "12px",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              border: "2px solid white",
            }}
          >
            {allToken.reduce((sum, token) => sum + token.count, 0)}
          </span>
        </div>
      </div>

      {/* Modal Portal */}
      {isModalOpen && createPortal(<ModalContent />, document.body)}
      
      {/* Confirmation Dialog Portal */}
      {confirmDialog.isOpen && createPortal(<ConfirmDialog />, document.body)}
    </>
  );
};

export default TokenInc;